import { EnvelopeSimple, MapPin, Phone } from "@phosphor-icons/react";
import { VISITOR_FORM_URL } from "@/constants/visitorForm";

export default function Contact() {
  return (
    <div data-testid="page-contact">
      {/* HERO */}
      <section className="border-b border-zinc-200" data-testid="contact-hero">
        <div className="container-x mx-auto py-20 lg:py-28">
          <div className="text-overline mb-6">Contact</div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] max-w-5xl">
            Let&apos;s build the<br />intelligent enterprise.
          </h1>
          <p className="mt-8 text-xl leading-relaxed text-zinc-600 max-w-3xl">
            Talk to our industrial intelligence team — share your operation, your goals, and we&apos;ll
            respond with a tailored consultation or demo.
          </p>
        </div>
      </section>

      {/* CONTACT GRID */}
      <section className="border-b border-zinc-200 bg-zinc-50" data-testid="contact-form-section">
        <div className="container-x mx-auto py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
            {/* Left — Info */}
            <div className="lg:col-span-4">
              <div className="border border-zinc-200 bg-white p-8">
                <div className="text-overline text-zinc-500 mb-6">Get in touch</div>
                <ul className="space-y-6">
                  <li className="flex items-start gap-4">
                    <EnvelopeSimple size={22} weight="light" className="text-zinc-950 mt-0.5" />
                    <div>
                      <div className="text-xs text-zinc-500 uppercase tracking-widest font-mono">Email</div>
                      <a
                        href="mailto:info@bizlem.com"
                        data-testid="contact-email-link"
                        className="text-lg font-semibold text-zinc-950 hover:text-sky-600 transition"
                      >
                        info@bizlem.com
                      </a>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <Phone size={22} weight="light" className="text-zinc-950 mt-0.5" />
                    <div>
                      <div className="text-xs text-zinc-500 uppercase tracking-widest font-mono">Business hours</div>
                      <div className="text-lg font-semibold text-zinc-950">24×7 Intelligent Operations</div>
                    </div>
                  </li>
                  <li className="flex items-start gap-4">
                    <MapPin size={22} weight="light" className="text-zinc-950 mt-0.5" />
                    <div>
                      <div className="text-xs text-zinc-500 uppercase tracking-widest font-mono">Focus</div>
                      <div className="text-lg font-semibold text-zinc-950">Global · Enterprise · Heavy Industry</div>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="mt-6 border border-zinc-200 bg-white p-8">
                <div className="text-overline text-zinc-500 mb-4">Prefer a quick chat?</div>
                <p className="text-zinc-600 mb-6">
                  Send us a note using the form — we&apos;ll match you with the right industry expert
                  within one business day.
                </p>
                <div className="flex flex-wrap gap-2">
                  {["30% Efficiency", "50+ AI Use Cases", "20+ Industries"].map((k) => (
                    <span key={k} className="text-xs font-mono uppercase tracking-widest border border-zinc-300 px-3 py-2">
                      {k}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Right — Visitor form */}
            <div className="lg:col-span-8">
              <div
                data-testid="contact-form"
                className="border border-zinc-200 bg-white overflow-hidden"
              >
                <iframe
                  src={VISITOR_FORM_URL}
                  title="Bizlem visitor form"
                  data-testid="contact-visitor-form-iframe"
                  className="w-full min-h-[720px] border-0"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
